import React from "react";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export default function Header() {
  const now = new Date();
  const day = now.getDate();
  const month = MONTHS[now.getMonth()].toUpperCase();
  const year = now.getFullYear();

  return (
    <header style={{
      background: "var(--white)",
      padding: "54px 20px 16px",
      borderBottom: "1px solid var(--border)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{
          width: 40, height: 40,
          background: "var(--sage)",
          borderRadius: 11,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontFamily: "'Playfair Display', serif",
          fontSize: 19, color: "white", flexShrink: 0,
        }}>P</div>
        <div>
          <div style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 19, fontWeight: 600, color: "var(--charcoal)", lineHeight: 1,
          }}>
            <span style={{ position: "relative" }}>
              Potterton
              <span style={{
                position: "absolute", bottom: -2, left: 0,
                width: "100%", height: 2,
                background: "var(--sage)", borderRadius: 2,
              }} />
            </span>
            {" "}HQ
          </div>
          <div style={{
            fontSize: 11, color: "var(--muted)", marginTop: 4,
            letterSpacing: "0.05em", textTransform: "uppercase", fontWeight: 600,
          }}>Family Dashboard</div>
        </div>
      </div>
      <div style={{ textAlign: "right" }}>
        <div style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 30, fontWeight: 500, color: "var(--charcoal)", lineHeight: 1,
        }}>{day}</div>
        <div style={{
          fontSize: 11, color: "var(--muted)",
          textTransform: "uppercase", letterSpacing: "0.08em",
          marginTop: 2, fontWeight: 600,
        }}>{month} {year}</div>
      </div>
    </header>
  );
}
